import React, { useState } from "react";
import { useTheme } from "../BrandColors/Context/ThemeContext";

const demoOptions = [
  {
    "steps": [
      {
        "boardData": [
          {
            "sentence": "Hello ${CUST_NAME}, My name is Aimee and I am your digital assistant.",
            "notepadData": {
              "selectedSentence": "Hello ${CUST_NAME}, My name is Aimee and I am your digital assistant.",
              "heading": "Hello ${CUST_NAME},",
              "subHeading": "I'm Aimee, your friendly digital assistant!",
              "content": "",
              "category": "",
              "isButton": false,
              "buttonText": "",
              "unselectionScrip": "",
              "reselectionScrip": "",
              "images": [
                {
                  "imgTitle": "",
                  "image": null
                }
              ]
            },
            "boardDataAdded": true
          },
          {
            "sentence": "Welcome to my office here at Pohanka Toyota.",
            "notepadData": {
              "selectedSentence": "Welcome to my office here at Pohanka Toyota.",
              "heading": "Pohanka Toyota of Salisbury",
              "subHeading": "Welcome to my digital office!",
              "content": "",
              "category": "",
              "isButton": false,
              "buttonText": "",
              "unselectionScrip": "",
              "reselectionScrip": "",
              "images": [
                {
                  "imgTitle": "",
                  "image": "https://provaantech-ai.s3.ap-south-1.amazonaws.com/uploads/1739394384271-test"
                }
              ]
            },
            "boardDataAdded": true
          },
          {
            "sentence": "It is my job to walk you through the financial services portion of the purchase of your ${CAR_YEAR} ${CAR_COLOR}, ${CAR_NAME} ${CAR_MODEL}.",
            "notepadData": {
              "selectedSentence": "It is my job to walk you through the financial services portion of the purchase of your ${CAR_YEAR} ${CAR_COLOR}, ${CAR_NAME} ${CAR_MODEL}.",
              "heading": "${CAR_YEAR} ${CAR_COLOR} ${CAR_NAME} ${CAR_MODEL}",
              "subHeading": "I will review your Financial Services Offerings",
              "content": "",
              "category": "",
              "isButton": false,
              "buttonText": "",
              "unselectionScrip": "",
              "reselectionScrip": "",
              "images": [
                {
                  "imgTitle": "",
                  "image": "https://provaantech-ai.s3.ap-south-1.amazonaws.com/uploads/1739397201476-test"
                }
              ]
            },
            "boardDataAdded": true
          },
          {
            "sentence": "I know time is important, so let’s review your bottom-line numbers, so After adding taxes and fees you have a total due of ${TOTAL_DUE}, and After your downpayment of ${DOWN_PAYMENT}, it leaves a base financed amount of ${FINANCE_AMOUNT}.",
            "notepadData": {
              "selectedSentence": "I know time is important, so let’s review your bottom-line numbers, so After adding taxes and fees you have a total due of ${TOTAL_DUE}, and After your downpayment of ${DOWN_PAYMENT}, it leaves a base financed amount of ${FINANCE_AMOUNT}.",
              "heading": "",
              "subHeading": "",
              "content": "",
              "category": "",
              "isButton": false,
              "buttonText": "",
              "unselectionScrip": "",
              "reselectionScrip": "",
              "images": []
            },
            "boardDataAdded": false
          },
          {
            "sentence": "Your loan is approved, and your lender has made advance allowances for optional service and gap agreements.",
            "notepadData": {
              "selectedSentence": "Your loan is approved, and your lender has made advance allowances for optional service and gap agreements.",
              "heading": "Your Loan is APPROVED",
              "subHeading": "You get to choose your loan structure",
              "content": "",
              "category": "",
              "isButton": false,
              "buttonText": "",
              "unselectionScrip": "",
              "reselectionScrip": "",
              "images": [
                {
                  "imgTitle": "",
                  "image": "https://provaantech-ai.s3.ap-south-1.amazonaws.com/uploads/1739395848750-test"
                }
              ]
            },
            "boardDataAdded": true
          },
          {
            "sentence": "These agreements determine who pays for things that can be happening in the future.",
            "notepadData": {
              "selectedSentence": "These agreements determine who pays for things that can be happening in the future.",
              "heading": "Who will pay for future vehicle ownership costs?",
              "subHeading": "Repairs - Maintenance -Tires & Wheels - Dings/Dents - Total Loss Coverage - Keys/Remotes",
              "content": "",
              "category": "",
              "isButton": false,
              "buttonText": "",
              "unselectionScrip": "",
              "reselectionScrip": "",
              "images": []
            },
            "boardDataAdded": true
          },
          {
            "sentence": "I will give you all the information you need and answer all of your questions so that you can pick the loan structure and ownership option that’s right for you.",
            "notepadData": {
              "selectedSentence": "I will give you all the information you need and answer all of your questions so that you can pick the loan structure and ownership option that’s right for you.",
              "heading": "I will guide you, and answer your questions.",
              "subHeading": "You pick the one that's best for you.",
              "content": "",
              "category": "",
              "isButton": false,
              "buttonText": "",
              "unselectionScrip": "",
              "reselectionScrip": "",
              "images": [
                {
                  "imgTitle": "",
                  "image": null
                }
              ]
            },
            "boardDataAdded": true
          },
          {
            "sentence": "Let’s begin with repairs, just click when you are ready.",
            "notepadData": {
              "selectedSentence": "Let’s begin with repairs, just click when you are ready.",
              "heading": "",
              "subHeading": "",
              "content": "",
              "category": "",
              "isButton": false,
              "buttonText": "",
              "unselectionScrip": "",
              "reselectionScrip": "",
              "images": []
            },
            "boardDataAdded": false
          }
        ],
        "category": "Intro",
        "number": 1,
        "reSelectionScript": "",
        "script": "Hello ${CUST_NAME}, My name is Aimee and I am your digital assistant. Welcome to my office here at Pohanka Toyota. It is my job to walk you through the financial services portion of the purchase of your ${CAR_YEAR} ${CAR_COLOR}, ${CAR_NAME} ${CAR_MODEL}. I know time is important, so let’s review your bottom-line numbers, so After adding taxes and fees you have a total due of ${TOTAL_DUE}, and After your downpayment of ${DOWN_PAYMENT}, it leaves a base financed amount of ${FINANCE_AMOUNT}. Your loan is approved, and your lender has made advance allowances for optional service and gap agreements. These agreements determine who pays for things that can be happening in the future.  I will give you all the information you need and answer all of your questions so that you can pick the loan structure and ownership option that’s right for you. Let’s begin with repairs, just click when you are ready.",
        "submitted": true,
        "title": "Intro",
        "unselectionScript": "",
        "buttonText": "Repairs"
      },
      {
        "boardData": [
          {
            "sentence": "Your lender, ${LENDER_NAME}, has approved you for a ${LENDING_TYPE} advance.",
            "notepadData": {
              "selectedSentence": "Your lender, ${LENDER_NAME}, has approved you for a ${LENDING_TYPE} advance.",
              "heading": "You are APPROVED for a TOYOTA SERVICE AGREEMENT",
              "subHeading": "This extends your 3/36 coverage to 7 Years or 100,000 Miles!",
              "content": "100% Parts and Labor on all Covered Repairs",
              "category": "",
              "isButton": false,
              "buttonText": "",
              "unselectionScrip": "",
              "reselectionScrip": "",
              "images": [
                {
                  "imgTitle": "",
                  "image": "https://provaantech-ai.s3.ap-south-1.amazonaws.com/uploads/1740138481216-test"
                }
              ]
            },
            "boardDataAdded": true
          },
          {
            "sentence": "With a ${LENDING_TYPE}, we will take care of all of your covered repairs for the next 7 years or 100,000 miles, even after your loan is paid off, giving you more than 3 times the length of coverage.",
            "notepadData": {
              "selectedSentence": "With a ${LENDING_TYPE}, we will take care of all of your covered repairs for the next 7 years or 100,000 miles, even after your loan is paid off, giving you more than 3 times the length of coverage.",
              "heading": "For many years to come:",
              "subHeading": "We will be paying for repairs instead of you!",
              "content": "7 Years or 100,000 Miles of Peace of Mind",
              "category": "",
              "isButton": false,
              "buttonText": "",
              "unselectionScrip": "",
              "reselectionScrip": "",
              "images": [
                {
                  "imgTitle": "",
                  "image": null
                }
              ]
            },
            "boardDataAdded": true
          },
          {
            "sentence": "Our mission is to save you money while keeping your ${CAR_MODEL} in peak condition,  Let's talk about Maintenance.",
            "notepadData": {
              "selectedSentence": "Our mission is to save you money while keeping your ${CAR_MODEL} in peak condition,  Let's talk about Maintenance.",
              "heading": "When repairs are covered, it's a great MONEY SAVER",
              "subHeading": "",
              "content": "",
              "category": "",
              "isButton": false,
              "buttonText": "",
              "unselectionScrip": "",
              "reselectionScrip": "",
              "images": [
                {
                  "imgTitle": "",
                  "image": "https://provaantech-ai.s3.ap-south-1.amazonaws.com/uploads/1739398655003-test"
                }
              ]
            },
            "boardDataAdded": true
          }
        ],
        "category": "Product Script",
        "number": 2,
        "reSelectionScript": "Good choice, the service agreement is back on and you will enjoy 7 years 100,000 miles of repair coverage.",
        "script": "Your lender, ${LENDER_NAME}, has approved you for a ${LENDING_TYPE} advance. With a ${LENDING_TYPE}, we will take care of all of your covered repairs for the next 7 years or 100,000 miles, even after your loan is paid off, giving you more than 3 times the length of coverage. Our mission is to save you money while keeping your ${CAR_MODEL} in peak condition,  Let's talk about Maintenance.",
        "submitted": true,
        "title": "Service Agreement",
        "unselectionScript": "By unselecting the Toyota Service Agreement, you will become responsible for your ${CAR_MODEL} repair cost after only 36,000 miles.  It's important to remember that your ${CAR_MODEL} has incredibly advanced technology built into each of it's mechanical and electrical systems. With a service agreement, when you have a problem, you simply call us and we handle the rest.  It's your choice, and i'm here to answer any questions you have.",
        "price": "3100",
        "priceTax": "0",
        "buttonText": "Maintenance "
      },
      {
        "boardData": [
          {
            "sentence": "your lender has approved you for a maintenance upgrade which increases your coverage to 75,000 miles.",
            "notepadData": {
              "selectedSentence": "your lender has approved you for a maintenance upgrade which increases your coverage to 75,000 miles.",
              "heading": "You are also approved for a maintenance upgrade ",
              "subHeading": "",
              "content": "We look forward to seeing you here!",
              "category": "",
              "isButton": false,
              "buttonText": "",
              "unselectionScrip": "",
              "reselectionScrip": "",
              "images": []
            },
            "boardDataAdded": true
          },
          {
            "sentence": "With a maintenance upgrade, whenever your ${CAR_MODEL} has a maintenance due, all required services will be taken care of and paid for by us, 100% parts and 100% labor.",
            "notepadData": {
              "selectedSentence": "With a maintenance upgrade, whenever your ${CAR_MODEL} has a maintenance due, all required services will be taken care of and paid for by us, 100% parts and 100% labor.",
              "heading": "Upgrade to 5 Years or 75,000 Miles of Maintenance",
              "subHeading": "Complete Basic Maintenance",
              "content": "",
              "category": "",
              "isButton": false,
              "buttonText": "",
              "unselectionScrip": "",
              "reselectionScrip": "",
              "images": [
                {
                  "imgTitle": "",
                  "image": "https://provaantech-ai.s3.ap-south-1.amazonaws.com/uploads/1739452103217-test"
                }
              ]
            },
            "boardDataAdded": true
          },
          {
            "sentence": "${CAR_NAME} technicians know your ${CAR_MODEL} best, and as I mentioned before, our mission is to save you money and keep your ${CAR_NAME} in peak condition.",
            "notepadData": {
              "selectedSentence": "${CAR_NAME} technicians know your ${CAR_MODEL} best, and as I mentioned before, our mission is to save you money and keep your ${CAR_NAME} in peak condition.",
              "heading": "All Recommended Services - Zero Deductible",
              "subHeading": "",
              "content": "",
              "category": "",
              "isButton": false,
              "buttonText": "",
              "unselectionScrip": "",
              "reselectionScrip": "",
              "images": [
                {
                  "imgTitle": "",
                  "image": "https://provaantech-ai.s3.ap-south-1.amazonaws.com/uploads/1739455672016-test"
                },
                {
                  "imgTitle": "",
                  "image": "https://provaantech-ai.s3.ap-south-1.amazonaws.com/uploads/1739455764057-test"
                }
              ]
            },
            "boardDataAdded": true
          },
          {
            "sentence": "Let's learn about Platinum Plus.",
            "notepadData": {
              "selectedSentence": "Let's learn about Platinum Plus.",
              "heading": "Toyota Technicians Know Your ${CAR_MODEL} Best!",
              "subHeading": "",
              "content": "",
              "category": "",
              "isButton": false,
              "buttonText": "",
              "unselectionScrip": "",
              "reselectionScrip": "",
              "images": [
                {
                  "imgTitle": "",
                  "image": "https://provaantech-ai.s3.ap-south-1.amazonaws.com/uploads/1739457294270-test"
                },
                {
                  "imgTitle": "",
                  "image": "https://provaantech-ai.s3.ap-south-1.amazonaws.com/uploads/1739457310310-test"
                },
                {
                  "imgTitle": "",
                  "image": "https://provaantech-ai.s3.ap-south-1.amazonaws.com/uploads/1739457326650-test"
                }
              ]
            },
            "boardDataAdded": true
          }
        ],
        "category": "Product Script",
        "number": 3,
        "reSelectionScript": "Ok, The maintenance upgrade is back on, and you will have up to 75,000 miles of maintenance coverage.  ",
        "script": "your lender has approved you for a maintenance upgrade which increases your coverage to 75,000 miles. With a maintenance upgrade, whenever your ${CAR_MODEL} has a maintenance due, all required services will be taken care of and paid for by us, 100% parts and 100% labor. ${CAR_NAME} technicians know your ${CAR_MODEL} best, and as I mentioned before, our mission is to save you money and keep your ${CAR_NAME} in peak condition.  Let's learn about Platinum Plus.",
        "submitted": true,
        "title": "Maintenance",
        "unselectionScript": "By declining the maintenance upgrade, you will be responsible for your 4-Runner maintenance costs after only 25,000 miles instead of 75,000. This gives you a partial bundle.",
        "price": "1200",
        "priceTax": "0",
        "buttonText": "Platinum Plus"
      },
      {
        "boardData": [
          {
            "sentence": "${CUST_NAME}, you have chosen a beautiful ${CAR_COLOR} for your ${CAR_MODEL}.",
            "notepadData": {
              "selectedSentence": "${CUST_NAME}, you have chosen a beautiful ${CAR_COLOR} for your ${CAR_MODEL}.",
              "heading": "${CUST_NAME}, ",
              "subHeading": "You have chosen a beautiful ${CAR_COLOR} for your ${CAR_MODEL}.\n",
              "content": "",
              "category": "",
              "isButton": false,
              "buttonText": "",
              "unselectionScrip": "",
              "reselectionScrip": "",
              "images": [
                {
                  "imgTitle": "",
                  "image": "https://provaantech-ai.s3.ap-south-1.amazonaws.com/uploads/1739402826759-test"
                }
              ]
            },
            "boardDataAdded": true
          },
          {
            "sentence": "It's one of the ${CAR_COLOR_MODE} colors and more prone to show dents and dings.",
            "notepadData": {
              "selectedSentence": "It's one of the ${CAR_COLOR_MODE} colors and more prone to show dents and dings.",
              "heading": "Being one of the ${CAR_COLOR_MODE} colors:",
              "subHeading": "dents and dings can be noticeable",
              "content": "",
              "category": "",
              "isButton": false,
              "buttonText": "",
              "unselectionScrip": "",
              "reselectionScrip": "",
              "images": [
                {
                  "imgTitle": "",
                  "image": null
                }
              ]
            },
            "boardDataAdded": true
          },
          {
            "sentence": "Platinum Plus is a loan option for 5 years and unlimited miles that pays to repair the most common of cosmetic damages.",
            "notepadData": {
              "selectedSentence": "Platinum Plus is a loan option for 5 years and unlimited miles that pays to repair the most common of cosmetic damages.",
              "heading": "Toyota Platinum Plus",
              "subHeading": "5 Years and Unlimited Miles",
              "content": "",
              "category": "",
              "isButton": false,
              "buttonText": "",
              "unselectionScrip": "",
              "reselectionScrip": "",
              "images": [
                {
                  "imgTitle": "",
                  "image": "https://provaantech-ai.s3.ap-south-1.amazonaws.com/uploads/1739458763315-test"
                }
              ]
            },
            "boardDataAdded": true
          },
          {
            "sentence": "Dents and dings are covered, as are windshield chips and cracks.",
            "notepadData": {
              "selectedSentence": "Dents and dings are covered, as are windshield chips and cracks.",
              "heading": "Dents/Dings - Windshield Chips, Cracks, Stars",
              "subHeading": "",
              "content": "",
              "category": "",
              "isButton": false,
              "buttonText": "",
              "unselectionScrip": "",
              "reselectionScrip": "",
              "images": [
                {
                  "imgTitle": "",
                  "image": "https://provaantech-ai.s3.ap-south-1.amazonaws.com/uploads/1739462275022-test"
                },
                {
                  "imgTitle": "",
                  "image": "https://provaantech-ai.s3.ap-south-1.amazonaws.com/uploads/1739462296082-test"
                }
              ]
            },
            "boardDataAdded": true
          },
          {
            "sentence": "Tires and Wheels are also covered, So When you run over a nail, (or anything else in the road), and you need a new tire, just give us a call and we will put a new one on.",
            "notepadData": {
              "selectedSentence": "Tires and Wheels are also covered, So When you run over a nail, (or anything else in the road), and you need a new tire, just give us a call and we will put a new one on.",
              "heading": "When you run over something that damages your tire",
              "subHeading": "Seriously, ANYTHING in the road; Nails, Screws, Debris, Potholes, etc",
              "content": "",
              "category": "",
              "isButton": false,
              "buttonText": "",
              "unselectionScrip": "",
              "reselectionScrip": "",
              "images": [
                {
                  "imgTitle": "",
                  "image": "https://provaantech-ai.s3.ap-south-1.amazonaws.com/uploads/1739462641261-test"
                }
              ]
            },
            "boardDataAdded": true
          },
          {
            "sentence": "When you hit something so hard it also breaks your rim, just call us and we will bolt a new one on from the factory.",
            "notepadData": {
              "selectedSentence": "When you hit something so hard it also breaks your rim, just call us and we will bolt a new one on from the factory.",
              "heading": "24 Hour Roadside Assistance will come to your aid.",
              "subHeading": "",
              "content": "",
              "category": "",
              "isButton": false,
              "buttonText": "",
              "unselectionScrip": "",
              "reselectionScrip": "",
              "images": [
                {
                  "imgTitle": "",
                  "image": "https://provaantech-ai.s3.ap-south-1.amazonaws.com/uploads/1739462658241-test"
                }
              ]
            },
            "boardDataAdded": true
          },
          {
            "sentence": "As an added convenience, we will pay for the replacement of lost or broken keys and remotes as well.",
            "notepadData": {
              "selectedSentence": "As an added convenience, we will pay for the replacement of lost or broken keys and remotes as well.",
              "heading": "When you drop your keys in a mud puddle...",
              "subHeading": "When they are broken or lost...",
              "content": "We pay up to $800 per Key/Remote",
              "category": "",
              "isButton": false,
              "buttonText": "",
              "unselectionScrip": "",
              "reselectionScrip": "",
              "images": [
                {
                  "imgTitle": "",
                  "image": "https://provaantech-ai.s3.ap-south-1.amazonaws.com/uploads/1739462678521-test"
                }
              ]
            },
            "boardDataAdded": true
          },
          {
            "sentence": "Not only do we cover these things your insurance company doesn't, we also have no deductible.",
            "notepadData": {
              "selectedSentence": "Not only do we cover these things your insurance company doesn't, we also have no deductible.",
              "heading": "We cover all of this with ZERO deductible!",
              "subHeading": "",
              "content": "",
              "category": "",
              "isButton": false,
              "buttonText": "",
              "unselectionScrip": "",
              "reselectionScrip": "",
              "images": [
                {
                  "imgTitle": "",
                  "image": "https://provaantech-ai.s3.ap-south-1.amazonaws.com/uploads/1739462725321-test"
                }
              ]
            },
            "boardDataAdded": true
          },
          {
            "sentence": "We want to keep your new ${CAR_MODEL} looking great.",
            "notepadData": {
              "selectedSentence": "We want to keep your new ${CAR_MODEL} looking great.",
              "heading": "Let's Keep your ${CAR_MODEL} Looking Great!",
              "subHeading": "",
              "content": "",
              "category": "",
              "isButton": false,
              "buttonText": "",
              "unselectionScrip": "",
              "reselectionScrip": "",
              "images": [
                {
                  "imgTitle": "",
                  "image": "https://provaantech-ai.s3.ap-south-1.amazonaws.com/uploads/1739462748981-test"
                }
              ]
            },
            "boardDataAdded": true
          },
          {
            "sentence": "Let's talk about gap.",
            "notepadData": {
              "selectedSentence": "Let's talk about gap.",
              "heading": "",
              "subHeading": "",
              "content": "",
              "category": "",
              "isButton": false,
              "buttonText": "",
              "unselectionScrip": "",
              "reselectionScrip": "",
              "images": []
            },
            "boardDataAdded": false
          }
        ],
        "category": "Product Script",
        "number": 4,
        "reSelectionScript": "By Re-selecting the Platinum Plan, We will be responsible for the most common of cosmetic repairs, such as tires and wheels, dents and dings, and key replacement. This agreement is for 5 years and unlimited miles.  ",
        "script": "${CUST_NAME}, you have chosen a beautiful ${CAR_COLOR} for your ${CAR_MODEL}. It's one of the ${CAR_COLOR_MODE} colors and more prone to show dents and dings.  Platinum Plus is a loan option for 5 years and unlimited miles that pays to repair the most common of cosmetic damages. Dents and dings are covered, as are windshield chips and cracks.  Tires and Wheels are also covered, So When you run over a nail, (or anything else in the road), and you need a new tire, just give us a call and we will put a new one on.  When you hit something so hard it also breaks your rim, just call us and we will bolt a new one on from the factory.  As an added convenience, we will pay for the replacement of lost or broken keys and remotes as well. Not only do we cover these things your insurance company doesn't, we also have no deductible. We want to keep your new ${CAR_MODEL} looking great.  Let's talk about gap.",
        "submitted": true,
        "title": "Platinum Plus",
        "unselectionScript": "By declining The Platinum Plan; you will not have coverage for dings, dents, and tires and wheels or windshield chips and cracks, unless you change your insurance deductible with ${INS_PROVIDER} to zero. ",
        "price": "1295",
        "priceTax": "0",
        "buttonText": "Gap Coverage"
      },
      {
        "boardData": [
          {
            "sentence": "When a vehicle is declared a total loss for whatever reason, the insurance company is not concerned with how much you still owe on your loan, that is because auto insurance will only pay book value regardless of how much you still owe.",
            "notepadData": {
              "selectedSentence": "When a vehicle is declared a total loss for whatever reason, the insurance company is not concerned with how much you still owe on your loan, that is because auto insurance will only pay book value regardless of how much you still owe.",
              "heading": "Insurance Companies Don't Pay the Loan Balance.",
              "subHeading": "They pay book or market value only.",
              "content": "",
              "category": "",
              "isButton": false,
              "buttonText": "",
              "unselectionScrip": "",
              "reselectionScrip": "",
              "images": [
                {
                  "imgTitle": "",
                  "image": null
                }
              ]
            },
            "boardDataAdded": true
          },
          {
            "sentence": "The remaining amount owed is called a deficiency balance, and Toyota Gap will pay for the portion that your insurance company doesn't cover.",
            "notepadData": {
              "selectedSentence": "The remaining amount owed is called a deficiency balance, and Toyota Gap will pay for the portion that your insurance company doesn't cover.",
              "heading": "Let's say you owe $40,000 and your car is totaled:",
              "subHeading": "And the insurance company pays $32,000",
              "content": "The remaining amount owed is $5,000. Toyota Gap will cover this deficiency balance.",
              "category": "",
              "isButton": false,
              "buttonText": "",
              "unselectionScrip": "",
              "reselectionScrip": "",
              "images": [
                {
                  "imgTitle": "",
                  "image": "https://provaantech-ai.s3.ap-south-1.amazonaws.com/uploads/1740067144216-test"
                }
              ]
            },
            "boardDataAdded": true
          },
          {
            "sentence": "Toyota Gap will also reimburse your insurance deductible.",
            "notepadData": {
              "selectedSentence": "Toyota Gap will also reimburse your insurance deductible.",
              "heading": "We pay remaining loan balance",
              "subHeading": "AND we reimburse your deductible with ${INS_PROVIDER}",
              "content": "",
              "category": "",
              "isButton": false,
              "buttonText": "",
              "unselectionScrip": "",
              "reselectionScrip": "",
              "images": [
                {
                  "imgTitle": "",
                  "image": null
                }
              ]
            },
            "boardDataAdded": true
          },
          {
            "sentence": "Now let's look at how these options work together.",
            "notepadData": {
              "selectedSentence": "Now let's look at how these options work together.",
              "heading": "",
              "subHeading": "",
              "content": "",
              "category": "",
              "isButton": false,
              "buttonText": "",
              "unselectionScrip": "",
              "reselectionScrip": "",
              "images": []
            },
            "boardDataAdded": false
          }
        ],
        "category": "Product Script",
        "number": 5,
        "reSelectionScript": "By reselecting the Gap coverage, you will not be responsible for your deficiency balance as a result of a total loss. We will also reimburse your insurance deductible with ${INS_PROVIDER}",
        "script": "When a vehicle is declared a total loss for whatever reason, the insurance company is not concerned with how much you still owe on your loan, that is because auto insurance will only pay book value regardless of how much you still owe. The remaining amount owed is called a deficiency balance, and Toyota Gap will pay for the portion that your insurance company doesn't cover. Toyota Gap will also reimburse your insurance deductible. Now let's look at how these options work together.",
        "submitted": true,
        "title": "Gap Coverage",
        "unselectionScript": "Ok ${CUST_NAME}, by declining Toyota gap coverage, you will be solely responsible for any deficiency balance in a total loss situation. This includes losses suffered due to uninsured drivers, as well as theft and flooding.",
        "price": "995",
        "priceTax": "0",
        "buttonText": "Choices"
      },
      {
        "boardData": [
          {
            "sentence": "${CUST_NAME}, this is your complete bundle structure and it is our best offering.",
            "notepadData": {
              "selectedSentence": "${CUST_NAME}, this is your complete bundle structure and it is our best offering.",
              "heading": "",
              "subHeading": "",
              "content": "",
              "category": "",
              "isButton": false,
              "buttonText": "",
              "unselectionScrip": "",
              "reselectionScrip": "",
              "images": []
            },
            "boardDataAdded": false
          },
          {
            "sentence": "In just a moment, you can click options to select or unselect them, and you can ask me questions.",
            "notepadData": {
              "selectedSentence": "In just a moment, you can click options to select or unselect them, and you can ask me questions.",
              "heading": "",
              "subHeading": "",
              "content": "",
              "category": "",
              "isButton": false,
              "buttonText": "",
              "unselectionScrip": "",
              "reselectionScrip": "",
              "images": []
            },
            "boardDataAdded": false
          }
        ],
        "category": "Summary Script",
        "number": 6,
        "reSelectionScript": "",
        "script": "${CUST_NAME}, this is your complete bundle structure and it is our best offering. In just a moment, you can click options to select or unselect them, and you can ask me questions.",
        "submitted": true,
        "title": "Bundle",
        "unselectionScript": "",
        "discountPercent": "0"
      },
      {
        "boardData": [
          {
            "sentence": "Very well ${CUST_NAME} I hope you found my services informative and engaging.",
            "notepadData": {
              "selectedSentence": "Very well ${CUST_NAME} I hope you found my services informative and engaging.",
              "heading": "",
              "subHeading": "",
              "content": "",
              "category": "",
              "isButton": false,
              "buttonText": "",
              "unselectionScrip": "",
              "reselectionScrip": "",
              "images": []
            },
            "boardDataAdded": false
          }
        ],
        "category": "Final Script",
        "number": 7,
        "reSelectionScript": "",
        "script": "Very well ${CUST_NAME} I hope you found my services informative and engaging.",
        "submitted": true,
        "title": "Final",
        "unselectionScript": ""
      }
    ],
    "promptInput": ""
  },
];

const DemoDataPage = () => {
  const [selectedData, setSelectedData] = useState(JSON.stringify(demoOptions[0], null, 2));
  const [copied, setCopied] = useState(false);
  const theme = useTheme() || "#3b82f6";

  const handleCopy = () => {
    navigator.clipboard.writeText(selectedData).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="min-h-screen w-full flex items-center justify-center p-6 animate-fade-in-up">
      <div className="glass-panel w-full max-w-4xl p-8 rounded-2xl shadow-2xl border border-blue-200/50 flex flex-col items-center">
        
        <div className="w-full mb-6 border-b border-blue-200/50 pb-4">
          <h1 className="text-3xl font-bold text-white tracking-tight">Copy Master Data</h1>
          <p className="text-sm text-slate-600 mt-2">View and copy the JSON master data below.</p>
        </div>

        <div className="w-full relative group">
          <textarea
            className="w-full bg-blue-50 border border-blue-200/50 rounded-xl p-4 text-slate-700 font-mono text-sm leading-relaxed outline-none focus:border-slate-500 transition-colors shadow-inner scrollbar-hide resize-y"
            rows="20"
            readOnly
            value={selectedData}
          />
          <button 
            onClick={handleCopy} 
            className="absolute top-4 right-4 px-4 py-2 rounded-lg font-medium shadow-lg transition-transform hover:-translate-y-0.5 active:translate-y-0 text-white flex items-center gap-2"
            style={{ backgroundColor: copied ? '#10b981' : theme }}
          >
            {copied ? (
              <>
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path></svg>
                Copied!
              </>
            ) : (
              <>
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"></path></svg>
                Copy
              </>
            )}
          </button>
        </div>
        
      </div>
    </div>
  );
};

export default DemoDataPage;